import React from 'react';
import {Datagrid, Filter, List, TextField, TextInput} from 'react-admin';

const AccessDeviceFilter = (props) => (
  <Filter {...props}>
    <TextInput label="ra.action.search" source="q" alwaysOn />
  </Filter>
);

export const EduSchoolList = props => (
  <List filters={<AccessDeviceFilter />} {...props}  perPage={25} exporter={false} >
    <Datagrid rowClick="edit" >
      <TextField source="id"/>
      <TextField source="name"/>
    </Datagrid>
</List>
);

export default EduSchoolList
